"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledPlainIconButton = require("./styled-plain-icon-button");
var _excluded = ["ariaLabel", "callback", "className", "color", "dataTestId", "disabled", "height", "icon", "srLabel", "size", "width"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback;
var sizes = ['large', 'medium', 'small'];
var propTypes = {
  icon: _propTypes["default"].element.isRequired,
  ariaLabel: _propTypes["default"].string,
  callback: _propTypes["default"].func,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  height: _propTypes["default"].string,
  width: _propTypes["default"].string,
  srLabel: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(sizes), _propTypes["default"].shape(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(function (acc, current) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, current, _propTypes["default"].oneOf(sizes)));
  }, {}))])
};
var defaultProps = {
  ariaLabel: undefined,
  callback: function callback() {},
  className: '',
  color: 'var(--color-global-black)',
  dataTestId: null,
  disabled: undefined,
  height: undefined,
  srLabel: undefined,
  size: 'small',
  width: undefined
};
var PlainIconButton = forwardRef(function (props, ref) {
  var ariaLabel = props.ariaLabel,
    callback = props.callback,
    className = props.className,
    color = props.color,
    dataTestId = props.dataTestId,
    disabled = props.disabled,
    height = props.height,
    icon = props.icon,
    srLabel = props.srLabel,
    size = props.size,
    width = props.width,
    other = _objectWithoutProperties(props, _excluded);
  var clickHandler = useCallback(function (event) {
    callback(event, ref);
  }, [callback, ref]);
  return /*#__PURE__*/_react["default"].createElement(_styledPlainIconButton.StyledPlainIconButton, _extends({
    "aria-label": ariaLabel,
    className: className,
    "data-testid": dataTestId,
    disabled: disabled,
    onClick: clickHandler,
    ref: ref
  }, other), /*#__PURE__*/_react["default"].createElement(_styledPlainIconButton.StyledIcon, {
    color: color,
    height: height,
    icon: icon,
    width: width,
    responsiveSize: size
  }), /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, srLabel));
});
PlainIconButton.propTypes = propTypes;
PlainIconButton.defaultProps = defaultProps;
var _default = exports["default"] = PlainIconButton;